import React from 'react';
import UsersTable from '../../shared/Tables/UsersTable';

class AdminUsers extends React.Component {

	render() {
		// console.log('AdminUsers: render');
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Utilisateurs</h5>
				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>
						Utilisateurs
					</div>

					<div className="card-block">
					<UsersTable type="0"/>
					</div>
				</div>
			</div>
			</div>
		);
	}
}

export default AdminUsers;